// tslint:disable:ordered-imports
/**
 * This is an auto-generated file. Do not edit this file directly. Please run `pnpm run prepare`.
 */
import { ComponentPropsWithoutRef, FC, useMemo } from 'react';
import { twMerge } from 'tailwind-merge';

import alertTriangle3 from './icons/alert-triangle.3.svg?react';
import alignRight013 from './icons/align-right-01.3.svg?react';
import announcement033 from './icons/announcement-03.3.svg?react';
import archive from './icons/archive.svg?react';
import arrowBlockLeft3 from './icons/arrow-block-left.3.svg?react';
import arrowBlockUp3 from './icons/arrow-block-up.3.svg?react';
import arrowCircleUp3 from './icons/arrow-circle-up.3.svg?react';
import arrowDown from './icons/arrow-down.svg?react';
import arrowLeft from './icons/arrow-left.svg?react';
import arrowRight from './icons/arrow-right.svg?react';
import arrowSquareLeft3 from './icons/arrow-square-left.3.svg?react';
import arrowSquareRight3 from './icons/arrow-square-right.3.svg?react';
import arrowUp from './icons/arrow-up.svg?react';
import banknote from './icons/banknote.svg?react';
import bell013 from './icons/bell-01.3.svg?react';
import bellRinging013 from './icons/bell-ringing-01.3.svg?react';
import bold013 from './icons/bold-01.3.svg?react';
import box3 from './icons/box.3.svg?react';
import brackets3 from './icons/brackets.3.svg?react';
import building013 from './icons/building-01.3.svg?react';
import building023 from './icons/building-02.3.svg?react';
import calendar from './icons/calendar.svg?react';
import calendarCheck023 from './icons/calendar-check-02.3.svg?react';
import calendarPlus013 from './icons/calendar-plus-01.3.svg?react';
import calendarPlus02 from './icons/calendar-plus-02.svg?react';
import check from './icons/check.svg?react';
import checkCircle3 from './icons/check-circle.3.svg?react';
import checkDone023 from './icons/check-done-02.3.svg?react';
import checkSquareBroken1 from './icons/check-square-broken.1.svg?react';
import checkSquare3 from './icons/check-square.3.svg?react';
import chevronDown from './icons/chevron-down.svg?react';
import chevronLeft from './icons/chevron-left.svg?react';
import chevronRight from './icons/chevron-right.svg?react';
import chevronRightDouble3 from './icons/chevron-right-double.3.svg?react';
import chevronSelectorVertical from './icons/chevron-selector-vertical.svg?react';
import chevronUp from './icons/chevron-up.svg?react';
import circle4 from './icons/circle.4.svg?react';
import clockStopwatch3 from './icons/clock-stopwatch.3.svg?react';
import clock3 from './icons/clock.3.svg?react';
import coinsHand3 from './icons/coins-hand.3.svg?react';
import coinsStacked013 from './icons/coins-stacked-01.3.svg?react';
import columns02 from './icons/columns-02.svg?react';
import columns033 from './icons/columns-03.3.svg?react';
import copy073 from './icons/copy-07.3.svg?react';
import cornerDownRight3 from './icons/corner-down-right.3.svg?react';
import cornerUpRight3 from './icons/corner-up-right.3.svg?react';
import creditCard013 from './icons/credit-card-01.3.svg?react';
import currencyDollar from './icons/currency-dollar.svg?react';
import currencyPound from './icons/currency-pound.svg?react';
import currencyR from './icons/currency-r.svg?react';
import cursorBox3 from './icons/cursor-box.3.svg?react';
import database013 from './icons/database-01.3.svg?react';
import dataflow03 from './icons/dataflow-03.svg?react';
import dataflow033 from './icons/dataflow-03.3.svg?react';
import dataflow043 from './icons/dataflow-04.3.svg?react';
import dotpoints013 from './icons/dotpoints-01.3.svg?react';
import dotsHorizontal3 from './icons/dots-horizontal.3.svg?react';
import dotsVertical3 from './icons/dots-vertical.3.svg?react';
import download013 from './icons/download-01.3.svg?react';
import draggable from './icons/draggable.svg?react';
import edit013 from './icons/edit-01.3.svg?react';
import edit023 from './icons/edit-02.3.svg?react';
import edit04 from './icons/edit-04.svg?react';
import edit053 from './icons/edit-05.3.svg?react';
import expand053 from './icons/expand-05.3.svg?react';
import expand063 from './icons/expand-06.3.svg?react';
import eyeOff3 from './icons/eye-off.3.svg?react';
import eye3 from './icons/eye.3.svg?react';
import file01 from './icons/file-01.svg?react';
import file02 from './icons/file-02.svg?react';
import file023 from './icons/file-02.3.svg?react';
import file04 from './icons/file-04.svg?react';
import file063 from './icons/file-06.3.svg?react';
import fileAttachment033 from './icons/file-attachment-03.3.svg?react';
import fileCheck013 from './icons/file-check-01.3.svg?react';
import fileCheck023 from './icons/file-check-02.3.svg?react';
import fileCsv from './icons/file-csv.svg?react';
import fileDownload033 from './icons/file-download-03.3.svg?react';
import fileInvoice from './icons/file-invoice.svg?react';
import filePlus033 from './icons/file-plus-03.3.svg?react';
import fileWord from './icons/file-word.svg?react';
import fileX013 from './icons/file-x-01.3.svg?react';
import filterFunnel013 from './icons/filter-funnel-01.3.svg?react';
import filterLines3 from './icons/filter-lines.3.svg?react';
import flipBackward3 from './icons/flip-backward.3.svg?react';
import flipForward3 from './icons/flip-forward.3.svg?react';
import folder from './icons/folder.svg?react';
import folderOpen from './icons/folder-open.svg?react';
import folderSearch3 from './icons/folder-search.3.svg?react';
import folder3 from './icons/folder.3.svg?react';
import globe013 from './icons/globe-01.3.svg?react';
import globe043 from './icons/globe-04.3.svg?react';
import grid013 from './icons/grid-01.3.svg?react';
import hash023 from './icons/hash-02.3.svg?react';
import helpCircle3 from './icons/help-circle.3.svg?react';
import helpSquare3 from './icons/help-square.3.svg?react';
import home023 from './icons/home-02.3.svg?react';
import home03 from './icons/home-03.svg?react';
import hourglass01 from './icons/hourglass-01.svg?react';
import image013 from './icons/image-01.3.svg?react';
import inbox013 from './icons/inbox-01.3.svg?react';
import infoCircle3 from './icons/info-circle.3.svg?react';
import infoOctagon3 from './icons/info-octagon.3.svg?react';
import infoSquare3 from './icons/info-square.3.svg?react';
import italic013 from './icons/italic-01.3.svg?react';
import key013 from './icons/key-01.3.svg?react';
import layoutLeft3 from './icons/layout-left.3.svg?react';
import lightbulb053 from './icons/lightbulb-05.3.svg?react';
import lineChartUp033 from './icons/line-chart-up-03.3.svg?react';
import link013 from './icons/link-01.3.svg?react';
import link043 from './icons/link-04.3.svg?react';
import linkBroken013 from './icons/link-broken-01.3.svg?react';
import linkExternal013 from './icons/link-external-01.3.svg?react';
import list from './icons/list.svg?react';
import listOrdered from './icons/list-ordered.svg?react';
import list3 from './icons/list.3.svg?react';
import loading013 from './icons/loading-01.3.svg?react';
import loading023 from './icons/loading-02.3.svg?react';
import lock013 from './icons/lock-01.3.svg?react';
import lockUnlocked013 from './icons/lock-unlocked-01.3.svg?react';
import logOut033 from './icons/log-out-03.3.svg?react';
import mail013 from './icons/mail-01.3.svg?react';
import mail023 from './icons/mail-02.3.svg?react';
import mail043 from './icons/mail-04.3.svg?react';
import mail053 from './icons/mail-05.3.svg?react';
import markerPin013 from './icons/marker-pin-01.3.svg?react';
import maximize013 from './icons/maximize-01.3.svg?react';
import menu013 from './icons/menu-01.3.svg?react';
import messageTextSquare013 from './icons/message-text-square-01.3.svg?react';
import microphone013 from './icons/microphone-01.3.svg?react';
import minimize013 from './icons/minimize-01.3.svg?react';
import minusSquare3 from './icons/minus-square.3.svg?react';
import minus3 from './icons/minus.3.svg?react';
import monitor013 from './icons/monitor-01.3.svg?react';
import notificationMessage from './icons/notification-message.svg?react';
import paperclip3 from './icons/paperclip.3.svg?react';
import passcodeLock3 from './icons/passcode-lock.3.svg?react';
import pdf from './icons/pdf.svg?react';
import pencilLine3 from './icons/pencil-line.3.svg?react';
import percent023 from './icons/percent-02.3.svg?react';
import phone013 from './icons/phone-01.3.svg?react';
import phoneOutgoing023 from './icons/phone-outgoing-02.3.svg?react';
import phone3 from './icons/phone.3.svg?react';
import plusCircle from './icons/plus-circle.svg?react';
import plusCircle3 from './icons/plus-circle.3.svg?react';
import plusSquare3 from './icons/plus-square.3.svg?react';
import plus3 from './icons/plus.3.svg?react';
import refreshCw01 from './icons/refresh-cw-01.svg?react';
import refreshCw05 from './icons/refresh-cw-05.svg?react';
import repeat043 from './icons/repeat-04.3.svg?react';
import searchLg3 from './icons/search-lg.3.svg?react';
import searchRefraction3 from './icons/search-refraction.3.svg?react';
import send013 from './icons/send-01.3.svg?react';
import server013 from './icons/server-01.3.svg?react';
import settings013 from './icons/settings-01.3.svg?react';
import settings02 from './icons/settings-02.svg?react';
import share03 from './icons/share-03.svg?react';
import shoppingCart023 from './icons/shopping-cart-02.3.svg?react';
import sliders013 from './icons/sliders-01.3.svg?react';
import snowflake013 from './icons/snowflake-01.3.svg?react';
import star013 from './icons/star-01.3.svg?react';
import star053 from './icons/star-05.3.svg?react';
import star063 from './icons/star-06.3.svg?react';
import stars033 from './icons/stars-03.3.svg?react';
import stopSquare3 from './icons/stop-square.3.svg?react';
import strikethrough013 from './icons/strikethrough-01.3.svg?react';
import switchHorizontal013 from './icons/switch-horizontal-01.3.svg?react';
import switchVertical013 from './icons/switch-vertical-01.3.svg?react';
import tag013 from './icons/tag-01.3.svg?react';
import thermometer023 from './icons/thermometer-02.3.svg?react';
import tool013 from './icons/tool-01.3.svg?react';
import trash013 from './icons/trash-01.3.svg?react';
import truck013 from './icons/truck-01.3.svg?react';
import truck023 from './icons/truck-02.3.svg?react';
import typeStrikethrough013 from './icons/type-strikethrough-01.3.svg?react';
import underline013 from './icons/underline-01.3.svg?react';
import upload013 from './icons/upload-01.3.svg?react';
import uploadCloud013 from './icons/upload-cloud-01.3.svg?react';
import user01 from './icons/user-01.svg?react';
import user03 from './icons/user-03.svg?react';
import userCircle3 from './icons/user-circle.3.svg?react';
import userMinus013 from './icons/user-minus-01.3.svg?react';
import userSquare3 from './icons/user-square.3.svg?react';
import userX01 from './icons/user-x-01.svg?react';
import users013 from './icons/users-01.3.svg?react';
import variable3 from './icons/variable.3.svg?react';
import videoFile from './icons/video-file.svg?react';
import videoRecorder3 from './icons/video-recorder.3.svg?react';
import wifiOff2 from './icons/wifi-off.2.svg?react';
import xCircle3 from './icons/x-circle.3.svg?react';
import xClose from './icons/x-close.svg?react';
import xSquare3 from './icons/x-square.3.svg?react';
import x3 from './icons/x.3.svg?react';

const icons = {
  'alert-triangle.3': alertTriangle3,
  'align-right-01.3': alignRight013,
  'announcement-03.3': announcement033,
  archive: archive,
  'arrow-block-left.3': arrowBlockLeft3,
  'arrow-block-up.3': arrowBlockUp3,
  'arrow-circle-up.3': arrowCircleUp3,
  'arrow-down': arrowDown,
  'arrow-left': arrowLeft,
  'arrow-right': arrowRight,
  'arrow-square-left.3': arrowSquareLeft3,
  'arrow-square-right.3': arrowSquareRight3,
  'arrow-up': arrowUp,
  banknote: banknote,
  'bell-01.3': bell013,
  'bell-ringing-01.3': bellRinging013,
  'bold-01.3': bold013,
  'box.3': box3,
  'brackets.3': brackets3,
  'building-01.3': building013,
  'building-02.3': building023,
  calendar: calendar,
  'calendar-check-02.3': calendarCheck023,
  'calendar-plus-01.3': calendarPlus013,
  'calendar-plus-02': calendarPlus02,
  check: check,
  'check-circle.3': checkCircle3,
  'check-done-02.3': checkDone023,
  'check-square-broken.1': checkSquareBroken1,
  'check-square.3': checkSquare3,
  'chevron-down': chevronDown,
  'chevron-left': chevronLeft,
  'chevron-right': chevronRight,
  'chevron-right-double.3': chevronRightDouble3,
  'chevron-selector-vertical': chevronSelectorVertical,
  'chevron-up': chevronUp,
  'circle.4': circle4,
  'clock-stopwatch.3': clockStopwatch3,
  'clock.3': clock3,
  'coins-hand.3': coinsHand3,
  'coins-stacked-01.3': coinsStacked013,
  'columns-02': columns02,
  'columns-03.3': columns033,
  'copy-07.3': copy073,
  'corner-down-right.3': cornerDownRight3,
  'corner-up-right.3': cornerUpRight3,
  'credit-card-01.3': creditCard013,
  'currency-dollar': currencyDollar,
  'currency-pound': currencyPound,
  'currency-r': currencyR,
  'cursor-box.3': cursorBox3,
  'database-01.3': database013,
  'dataflow-03': dataflow03,
  'dataflow-03.3': dataflow033,
  'dataflow-04.3': dataflow043,
  'dotpoints-01.3': dotpoints013,
  'dots-horizontal.3': dotsHorizontal3,
  'dots-vertical.3': dotsVertical3,
  'download-01.3': download013,
  draggable: draggable,
  'edit-01.3': edit013,
  'edit-02.3': edit023,
  'edit-04': edit04,
  'edit-05.3': edit053,
  'expand-05.3': expand053,
  'expand-06.3': expand063,
  'eye-off.3': eyeOff3,
  'eye.3': eye3,
  'file-01': file01,
  'file-02': file02,
  'file-02.3': file023,
  'file-04': file04,
  'file-06.3': file063,
  'file-attachment-03.3': fileAttachment033,
  'file-check-01.3': fileCheck013,
  'file-check-02.3': fileCheck023,
  'file-csv': fileCsv,
  'file-download-03.3': fileDownload033,
  'file-invoice': fileInvoice,
  'file-plus-03.3': filePlus033,
  'file-word': fileWord,
  'file-x-01.3': fileX013,
  'filter-funnel-01.3': filterFunnel013,
  'filter-lines.3': filterLines3,
  'flip-backward.3': flipBackward3,
  'flip-forward.3': flipForward3,
  folder: folder,
  'folder-open': folderOpen,
  'folder-search.3': folderSearch3,
  'folder.3': folder3,
  'globe-01.3': globe013,
  'globe-04.3': globe043,
  'grid-01.3': grid013,
  'hash-02.3': hash023,
  'help-circle.3': helpCircle3,
  'help-square.3': helpSquare3,
  'home-02.3': home023,
  'home-03': home03,
  'hourglass-01': hourglass01,
  'image-01.3': image013,
  'inbox-01.3': inbox013,
  'info-circle.3': infoCircle3,
  'info-octagon.3': infoOctagon3,
  'info-square.3': infoSquare3,
  'italic-01.3': italic013,
  'key-01.3': key013,
  'layout-left.3': layoutLeft3,
  'lightbulb-05.3': lightbulb053,
  'line-chart-up-03.3': lineChartUp033,
  'link-01.3': link013,
  'link-04.3': link043,
  'link-broken-01.3': linkBroken013,
  'link-external-01.3': linkExternal013,
  list: list,
  'list-ordered': listOrdered,
  'list.3': list3,
  'loading-01.3': loading013,
  'loading-02.3': loading023,
  'lock-01.3': lock013,
  'lock-unlocked-01.3': lockUnlocked013,
  'log-out-03.3': logOut033,
  'mail-01.3': mail013,
  'mail-02.3': mail023,
  'mail-04.3': mail043,
  'mail-05.3': mail053,
  'marker-pin-01.3': markerPin013,
  'maximize-01.3': maximize013,
  'menu-01.3': menu013,
  'message-text-square-01.3': messageTextSquare013,
  'microphone-01.3': microphone013,
  'minimize-01.3': minimize013,
  'minus-square.3': minusSquare3,
  'minus.3': minus3,
  'monitor-01.3': monitor013,
  'notification-message': notificationMessage,
  'paperclip.3': paperclip3,
  'passcode-lock.3': passcodeLock3,
  pdf: pdf,
  'pencil-line.3': pencilLine3,
  'percent-02.3': percent023,
  'phone-01.3': phone013,
  'phone-outgoing-02.3': phoneOutgoing023,
  'phone.3': phone3,
  'plus-circle': plusCircle,
  'plus-circle.3': plusCircle3,
  'plus-square.3': plusSquare3,
  'plus.3': plus3,
  'refresh-cw-01': refreshCw01,
  'refresh-cw-05': refreshCw05,
  'repeat-04.3': repeat043,
  'search-lg.3': searchLg3,
  'search-refraction.3': searchRefraction3,
  'send-01.3': send013,
  'server-01.3': server013,
  'settings-01.3': settings013,
  'settings-02': settings02,
  'share-03': share03,
  'shopping-cart-02.3': shoppingCart023,
  'sliders-01.3': sliders013,
  'snowflake-01.3': snowflake013,
  'star-01.3': star013,
  'star-05.3': star053,
  'star-06.3': star063,
  'stars-03.3': stars033,
  'stop-square.3': stopSquare3,
  'strikethrough-01.3': strikethrough013,
  'switch-horizontal-01.3': switchHorizontal013,
  'switch-vertical-01.3': switchVertical013,
  'tag-01.3': tag013,
  'thermometer-02.3': thermometer023,
  'tool-01.3': tool013,
  'trash-01.3': trash013,
  'truck-01.3': truck013,
  'truck-02.3': truck023,
  'type-strikethrough-01.3': typeStrikethrough013,
  'underline-01.3': underline013,
  'upload-01.3': upload013,
  'upload-cloud-01.3': uploadCloud013,
  'user-01': user01,
  'user-03': user03,
  'user-circle.3': userCircle3,
  'user-minus-01.3': userMinus013,
  'user-square.3': userSquare3,
  'user-x-01': userX01,
  'users-01.3': users013,
  'variable.3': variable3,
  'video-file': videoFile,
  'video-recorder.3': videoRecorder3,
  'wifi-off.2': wifiOff2,
  'x-circle.3': xCircle3,
  'x-close': xClose,
  'x-square.3': xSquare3,
  'x.3': x3,
} as const;

export type TIconName = keyof typeof icons;

interface IProps extends ComponentPropsWithoutRef<'svg'> {
  name: TIconName;
}

const UntitledIcon: FC<IProps> = (props) => {
  const { name, className, vectorEffect, ...svgProps } = props;

  const ImportedIcon = useMemo(() => icons[name], [name]);

  return (
    <ImportedIcon
      {...svgProps}
      className={twMerge(
        vectorEffect === 'non-scaling-stroke' ? 'non-scaling-stroke' : '',
        'h-[1lh] w-[1lh]',
        className
      )}
    />
  );
};

export default UntitledIcon;
